import clientsAdmin from './admin/client';
import settingsAdmin from './admin/settings';
import userAdmin from './admin/user';
import translationAdmin from './admin/translation';
import { ApiFactoryClassType } from './factory';

const admin = (factory: ApiFactoryClassType) => ({
    client: clientsAdmin(factory),
    settings: settingsAdmin(factory),
    user: userAdmin(factory),
    translation: translationAdmin(factory),
});

export default admin;
